import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Layout, Dropdown, Menu, Avatar, Input, Modal, Button } from 'antd';
import withStyles from 'react-jss';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  SettingOutlined,
  LogoutOutlined,
  AuditOutlined,
} from '@ant-design/icons';
import { useForm, Controller } from 'react-hook-form';

import styles from './styles';
import { logout } from '../Actions';
import GetField from '../Components/GetField';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';

const AntPassword = GetField(Input.Password);

const { Header } = Layout;

const Navbar = props => {
  const { classes, setCollapsed, collapsed, setVisible, visible } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const { control, handleSubmit } = useForm();

  const auth = useSelector(state => state.auth);

  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const toggleCollapse = useCallback(() => {
    setCollapsed(!collapsed);
  }, [collapsed]);

  const toggleDrawerCollapse = useCallback(() => {
    setVisible(!visible);
  }, [visible]);

  const showChangePasswordModal = useCallback(() => {
    setChangePasswordModal(true);
  }, []);

  const hideChangePasswordModal = useCallback(() => {
    setChangePasswordModal(false);
    setConfirmLoading(false);
  }, []);

  const onLogout = useCallback(() => {
    dispatch(logout());
    history.push('/login');
  }, []);

  const onSubmit = async formValues => {
    try {
      setConfirmLoading(true);
      const { password, newPassword } = formValues;
      await Api.post('/auth/change', { password, newPassword });
      successNotification('Password changed');
      hideChangePasswordModal();
    } catch (err) {
      errorNotification(err);
    }
  };

  const AccountMenu = (
    <Menu className={classes.navBarMenu}>
      <Menu.Item key="user">
        <UserOutlined />
        {auth.user.name}
      </Menu.Item>
      <Menu.Item key="role">
        <AuditOutlined />
        {auth.user.role}
      </Menu.Item>
      <Menu.Item key="changepassword" onClick={showChangePasswordModal}>
        <SettingOutlined />
        Change Password
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" onClick={onLogout}>
        <LogoutOutlined />
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <Header className={classes.header}>
        <div
          onClick={toggleCollapse}
          role="button"
          tabIndex={0}
          onKeyPress={toggleCollapse}
          className={classes.collapseIcon}
        >
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </div>
        <div
          onClick={toggleDrawerCollapse}
          role="button"
          tabIndex={0}
          onKeyPress={toggleDrawerCollapse}
          className={classes.collapseDrawerIcon}
        >
          {visible ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </div>

        <Dropdown overlay={AccountMenu} trigger={['click']}>
          <span className={classes.action}>
            <Avatar className={classes.avatar} alt="avatar">
              <UserOutlined />
            </Avatar>
          </span>
        </Dropdown>
      </Header>
      <Modal
        visible={changePasswordModal}
        onCancel={hideChangePasswordModal}
        centered
        title="Change password"
        width="30%"
        confirmLoading={confirmLoading}
        maskClosable={false}
        footer={false}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <AntPassword
                required
                allowClear
                placeholder="Current Password"
                {...field}
              />
            )}
          />
          <Controller
            name="newPassword"
            control={control}
            render={({ field }) => (
              <AntPassword
                required
                allowClear
                placeholder="New Password"
                {...field}
              />
            )}
          />
          <Button type="primary" loading={confirmLoading} htmlType="submit">
            Submit
          </Button>
        </form>
      </Modal>
    </div>
  );
};

Navbar.propTypes = {
  classes: PropTypes.object.isRequired,
  setCollapsed: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default withStyles(styles)(Navbar);
